<style>
    .wrapperx {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
    }

    .m-form .m-form__group:first-child {
        padding-top: 15px;
    }

</style>

<template>
    <form method="POST" class="m-form m-form--state" id="myForm" v-on:submit.prevent="save">
        <div class="row m-portlet__body">
            <div class="col-md-9">
                <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('name')}">
                    <label>
                        {{$t('Név')}}
                    </label>
                    <input type="text" class="form-control m-input" v-model="model.name">
                    <div class="form-control-feedback">
                        <span v-for="message in filter('name')" v-bind:key="message">
                            {{message}} <br/>
                        </span>
                    </div>
                </div>
                <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('url')}">
                    <label>
                        {{$t('URL')}}
                    </label>
                    <input type="text" class="form-control m-input" v-model="model.url">
                    <div class="form-control-feedback">
                        <span v-for="message in filter('url')" v-bind:key="message">
                            {{message}} <br/>
                        </span>
                    </div>
                </div>
                <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('content')}">
                    <label>
                        {{$t('Leírás')}}
                    </label>
                    <textarea class="form-control m-input" rows="3" v-model="model.content"></textarea>
                    <div class="form-control-feedback">
                            <span v-for="message in filter('content')" v-bind:key="message">
                                {{message}} <br/>
                            </span>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('meta_image')}">
                    <label>
                        {{$t('Oldal kép')}}
                    </label>
                    <input type="file" accept="image/*" class="form-control m-input" id="file1" ref="file1" name="uploadFile1" @change="handleUpload('file1')" />
                    <img class="img-fluid" v-if="model.meta_image !== null" :src="model.meta_image_url" />
                    <div class="form-control-feedback">
                            <span v-for="message in filter('meta_image')" v-bind:key="message">
                                {{message}} <br/>
                            </span>
                    </div>
                </div>
                <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('meta_keywords')}">
                    <label>
                        {{$t('Meta kulcsszavak')}}
                    </label>
                    <input type="text" class="form-control m-input" v-model="model.meta_keywords">
                    <div class="form-control-feedback">
                        <span v-for="message in filter('meta_keywords')" v-bind:key="message">
                            {{message}} <br/>
                        </span>
                    </div>
                </div>
                <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('meta_description')}">
                    <label>
                        {{$t('Meta leírás')}}
                    </label>
                    <textarea class="form-control m-input" rows="3" v-model="model.meta_description"></textarea>
                    <div class="form-control-feedback">
                            <span v-for="message in filter('meta_description')" v-bind:key="message">
                                {{message}} <br/>
                            </span>
                    </div>
                </div>
            </div>
        </div>
        <Buttons v-on:save="save" :list-link="`/admin/designs/index`"></Buttons>
    </form>
</template>

<script>
import Buttons from '../../core/form/Buttons'
import CKEditor from '../../core/CKEditor'
export default {
  name: 'PageForm',
  components: {CKEditor, Buttons},
  props: {
    model: {
      type: Object,
      required: true
    },
    errors: {
      type: Object
    },
    url: {
      require: true
    }
  },
  data () {
    return {
      file: null,
      image: null
    }
  },
  watch: {
    model: {
      handler (val) {
        this.$store.commit('loading/changeUnsaved', true)
        if (val && val.url !== undefined && val.url !== null) {
          this.model.url = this.model.url.toLowerCase()
          if (val.url.startsWith('/') === false) {
            this.model.url = '/' + this.model.url
          }
          this.model.url = this.model.url.replace(' ', '-')
        }
      },
      deep: true
    }
  },
  methods: {
    hasError (val) {
      for (let er in this.errors) {
        if (er === val) {
          return true
        }
      }

      return false
    },
    save () {
      this.$store.commit('loading/changeUnsaved', false)
      this.$emit('save')
    },
    filter: function (name) {
      for (let er in this.errors) {
        if (er === name) {
          this.hasDanger = true
          return this.errors[er]
        }
      }

      this.hasDanger = false
      return ''
    },
    handleUpload (ref) {
      this.file = this.$refs[ref].files[0]
      this.errors = {}
      if (this.file === '' || this.file === null) {
        this.errors['file'] = []
        this.errors.item_file_name.push(this.$translate.t('Fájl megadása kötelező!'))
      }

      if (JSON.stringify(this.errors) !== JSON.stringify({})) {
        this.$forceUpdate()
        return false
      }

      let formData = new FormData()
      formData.append('file', this.file)
      let self = this
      this.$http
        .post(process.env.API_URL + '/api/v1/admin/settings/upload-file', formData, {
          'headers': {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          if (ref === 'file1') {
            self.model.meta_image = res.data.data.path
            self.model.meta_image_url = res.data.data.uri
          }
          self.file = null
          window.$('#file').val(null)
        }).catch(res => {

        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/page/PageForm.vue